import React from "react";
import { Navigate } from "react-router-dom";

const K12LearnerJourney = () => {
  return <Navigate to="/work/k12-learner-journey" replace />;
};

export default K12LearnerJourney;
